import { HostedCompute } from "./HostedCompute";

export default HostedCompute;
